<div class="corpo">
  @if(isMenu.length) {
    <div class="menu-desktop">
      <menu></menu>
    </div>
  }

  <div class="main-area">
    @if(isMenu.length) {
      <navbar></navbar>
    }


    <div class="contents">
      <router-outlet class="outlet"></router-outlet>
    </div>
  </div>

  @if(isMenu.length) {
    <div class="menu-footer">
      <menu></menu>
    </div>
  }
</div>

<tgt-loader [size]="'large'"></tgt-loader>
